import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ContentTextComponent } from '../content-text/content-text.component';
import { ContentTitleComponent } from '../content-title/content-title.component';
import { MenuNavigationService } from 'app/services/menu-navigation.service';
import { FooterComponent } from '../footer/footer.component';
import { AnalyticsService } from 'app/services/analytics.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-reference',
  templateUrl: './reference.component.html',
  styleUrls: ['./reference.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    TranslateModule,
    CommonModule,
    FormsModule,
    ContentTitleComponent,
    ContentTextComponent,
    FooterComponent,
  ],
})
export class ReferenceComponent implements OnInit {
  protected isReferencesModalOpen = false;
  protected productList = [];
  protected selectedProduct = [];
  protected referenceOverlays = [];
  protected title = [];
  @Input() protected reference = false;
  @Input() protected showAllReferences = false;
  @Output() protected showReferencesModal = new EventEmitter();
  private readonly subscriptions: Subscription = new Subscription();

  protected references: Array<{ title: string; overlay: [] }> = [];

  constructor(
    protected menuNavigationService: MenuNavigationService,
    protected analytics: AnalyticsService
  ) {
    this.productList = this.menuNavigationService.productList;
  }

  public ngOnInit() {
    this.updateReferences();
  }

  protected updateReferences() {
    const subscription = this.menuNavigationService.productListObservable.subscribe(data => {
      this.referenceOverlays = [];
      this.references = [];
      this.menuNavigationService.selectedSectionIndex = data.selectedSectionIndex;
      this.menuNavigationService.selectedProductIndex = data.selectedProductIndex;
      this.selectedProduct = this.productList[this.menuNavigationService.selectedProductIndex];
      this.showReferences();
    });

    this.menuNavigationService.getReferencesClicked.subscribe((data: boolean) => {
      if (data) {
        this.referenceOverlays = [];
        this.references = [];
        this.selectedProduct = this.productList[this.menuNavigationService.selectedProductFromMegaMenu];
        this.showReferences();
      }
    });
    this.subscriptions.add(subscription);
  }

  protected ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  protected showReferences() {
    if (this.showAllReferences && this.selectedProduct?.['sections']) {
      for (const section of this.selectedProduct['sections']) {
        this.references.push({
          title: section.title,
          overlay: section.referenceOverlay,
        });
      }
      this.referenceOverlays = this.references;
    } else {
      this.referenceOverlays.push({
        overlay: this.productList[this.menuNavigationService.selectedProductIndex]?.sections[
          this.menuNavigationService.selectedSectionIndex
        ]?.referenceOverlay
      });
    }
  }

  protected hideReferences() {
    this.reference = false;
    this.showReferencesModal.emit(this.reference);
  }
}
